import { AnalyticsContext } from '@carvana/eventable-clickstream';
import { useExperimentBucket } from '@carvana/experiment';
import { useContext, useState, useEffect } from 'react';
import AnimateHeight from 'react-animate-height';
import AppliedFiltersContext from '~/contexts/AppliedFiltersContext';
import FacetDataContext from '~/contexts/FacetDataContext';
import FilterDrawer from './FilterDrawer';
import RangeSlider from './RangeSlider';
import type WithClassName from './WithClassName';

function TowingCapacity({ className }: WithClassName) {
  const { trackEvent } = useContext(AnalyticsContext);
  const { facetData } = useContext(FacetDataContext);
  const { appliedFilters, updateRangeFilter } = useContext(
    AppliedFiltersContext
  );

  const experimentBucket = useExperimentBucket('srch-set-reduction2');
  const [expand, setExpand] = useState(false);

  const show =
    (experimentBucket === 'control'
      ? appliedFilters.bodyStyles?.includes('Pickup') &&
        facetData?.towingCapacity
      : facetData?.towingCapacity && facetData?.towingCapacity?.min > 0) ||
    false;

  useEffect(() => {
    if (!show) setExpand(false);
  }, [show]);

  return (
    <AnimateHeight duration={500} height={show ? 'auto' : 0}>
      <FilterDrawer
        className={className}
        dataQa="facet-towing-capacity"
        facetContent
        facetName="Towing Capacity"
        show={expand}
        onToggle={() => setExpand(v => !v)}
      >
        <div className="gap-32 grid px-24 py-32">
          <RangeSlider
            data-analytics-id="adjust-towing-capacity-range"
            format="number"
            isShowing={expand}
            id="facet-towing-capacity"
            label="Tow Capacity"
            dualRange
            min={facetData.towingCapacity?.min}
            max={facetData.towingCapacity?.max}
            initialValues={[
              appliedFilters.towingCapacity?.min ??
                facetData.towingCapacity?.min ??
                0,
              appliedFilters.towingCapacity?.max ??
                facetData.towingCapacity?.max ??
                0
            ]}
            onUpdate={v => {
              updateRangeFilter({
                filterKey: 'towingCapacity',
                value: {
                  min: v?.[0] ?? facetData.towingCapacity?.min,
                  max: v?.[1] ?? facetData.towingCapacity?.max
                }
              });
              trackEvent('Filter towing capacity', {
                min: v?.[0] ?? facetData.towingCapacity?.min,
                max: v?.[1] ?? facetData.towingCapacity?.max
              });
            }}
          />
        </div>
      </FilterDrawer>
    </AnimateHeight>
  );
}

export default TowingCapacity;
